module.exports = __webpack_public_path__ + "static/partners-fe019b50490394d9a0b13b3d07e74740.png";